
import agro from '../../assets/images/default/people/agro.webp';
import biotech from '../../assets/images/default/people/biotech.webp';
import education from '../../assets/images/default/people/education.webp';
import energetics from '../../assets/images/default/people/energetics.webp';
import geology from '../../assets/images/default/people/geology.webp';
import himtech from '../../assets/images/default/people/himtech.webp';
import machine from '../../assets/images/default/people/machine.webp';
import materials from '../../assets/images/default/people/materials.webp';
import infosec from '../../assets/images/default/people/infosec.webp';
import it from '../../assets/images/default/people/it.webp';
import safetech from '../../assets/images/default/people/safetech.webp';
import service from '../../assets/images/default/people/serviceMain.webp';
import techcontrol from '../../assets/images/default/people/techcontrol.webp';
import transportMain from '../../assets/images/default/people/transportMain.webp';
import techprom from '../../assets/images/default/people/techpromMain.webp';
import stroy from '../../assets/images/default/people/stroy.webp';
import economy from '../../assets/images/default/people/economy.webp';
import pravo from '../../assets/images/default/people/pravo.webp';
import radioelectronic from '../../assets/images/default/people/radioelectronicShown.webp';
import trade from '../../assets/images/default/people/trade.webp';

import agroMountin from '../../assets/images/mountins/agroMountin.webp';
import biotechMountin from '../../assets/images/mountins/biotechMountin.webp';
import economyMountin from '../../assets/images/mountins/economyMountin.webp';
import educationMountin from '../../assets/images/mountins/eductionMountin.webp';
import electricsMountin from '../../assets/images/mountins/electricsMountin.webp';
import geologyMountin from '../../assets/images/mountins/geologyMountin.webp';
import himtechMountin from '../../assets/images/mountins/himTechMountin.webp';
import infosecMountin from '../../assets/images/mountins/infosecMountin.webp';
import itMountin from '../../assets/images/mountins/itMountin.webp';
import machineMountin from '../../assets/images/mountins/machineMountin.webp';
import materialsMountin from '../../assets/images/mountins/materialsMountin.webp';
import pravoMountin from '../../assets/images/mountins/pravoMountin.webp';
import radioelectronicMoutin from '../../assets/images/mountins/radioelectronicMoutin.webp';
import safetechMountin from '../../assets/images/mountins/safetechMountin.webp';
import serviceMountin from '../../assets/images/mountins/serviceMountin.webp';
import stroyMountin from '../../assets/images/mountins/stroyMountin.webp';
import techcontrolMountin from '../../assets/images/mountins/techcontrolMountin.webp';
import techpromMountin from '../../assets/images/mountins/techpromMountin.webp';
import transportMountin from '../../assets/images/mountins/transportMountin.webp';
import tradeMountin from '../../assets/images/mountins/tradeMountin.webp';

export const jobs = [
  {
    id: 'education',
    type: 'motion',
    position: { top: 1289, left: 53, width: 187, height: 249 },
    spaceTopSmall: 0,
    text: {
      content: 'Образование\nи педагогические\nнауки',
      isRight: true,
      top: 54,
      width: 194,
      height: 48,
      spacing: 148,
    },
    person: {
      src: education,
      width: 134,
      height: 200,
      top: 0,
      left: 48,
      isMirror: false,
    },
    mountain: {
      src: educationMountin,
      width: 187,
      height: 206,
      top: 40,
      left: 0,
    },
    modal: {
      top: 90,
      right: -280,
      width: 380,
      isMirror: true,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
  {
    id: 'techcontrol',
    type: 'motion',
    position: { top: 1967, left: 182, width: 201, height: 213 },
    spaceTopSmall: 0,
    text: {
      content: 'Управление\nв технических системах',
      isRight: true,
      top: 51,
      width: 229,
      spacing: 150,
    },
    person: {
      src: techcontrol,
      width: 146,
      height: 218,
      top: -30,
      left: 85,
      isMirror: true,
    },
    mountain: {
      src: techcontrolMountin,
      width: 200,
      height: 200,
      top: 13,
      left: 0,
    },
    modal: {
      width: 380,
      top: 80,
      right: -250,
      isMirror: true,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
  {
    id: 'pravo',
    type: 'motion',
    position: { top: 810, left: 151, width: 213, height: 190 },
    spaceTopSmall: 0,
    text: {
      content: 'юриспруденция',
      isRight: false,
      top: 40,
      width: 195,
      height: 34,
      spacing: 104,
    },
    person: {
      src: pravo,
      width: 104,
      height: 184,
      top: 0,
      left: 27,
      isMirror: false,
    },
    mountain: {
      src: pravoMountin,
      width: 219,
      height: 179,
      top: 11,
      left: 0,
    },
    modal: {
      width: 420,
      top: 55,
      height: 200,
      right: -180,
      $titleWidth: 200,
      $textWidth: 200,
      isMirror: true
    },
    hasCircle: false,
  },
  {
    id: 'radioelectronic',
    type: 'motion',
    position: { top: 965, left: 1036, width: 251, height: 192 },
    spaceTopSmall: 60,
    text: {
      content: 'Электроника, радиотехника\nи системы связи',
      isRight: false,
      top: 55,
      width: 264,
      spacing: 220,
    },
    person: {
      src: radioelectronic,
      width: 83,
      height: 175,
      top: 0,
      left: 13,
      isMirror: true,
    },
    mountain: {
      src: radioelectronicMoutin,
      width: 251,
      height: 192,
      top: 1,
      left: 0,
    },
    modal: {
      width: 400,
      top: 85,
      right: 120,
      isMirror: false,
      $textWidth: 270,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
  {
    id: 'geology',
    type: 'absolute',
    position: { top: 1233, left: 522, width: 327, height: 206 },
    text: {
      content: 'Прикладная геология,\nгорное дело, нефтегазовое\nдело и геодезия',
      isRight: true,
      top: 40,
      width: 276,
      spacing: 163,
    },
    person: {
      src: geology,
      width: 106 * 1.2,
      height: 170 * 1.2,
      top: -10,
      left: 178,
      isMirror: true,
    },
    mountain: {
      src: geologyMountin,
      width: 327,
      height: 206,
      top: 0,
      left: 0,
    },
    modal: {
      width: 425,
      top: 70,
      height: 200,
      right: -250,
      $paddingTop: 25,
      isMirror: true,
    },
    hasCircle: false,
  },
  {
    id: 'trade',
    type: 'absolute',
    position: { top: 762, left: 468, width: 250, height: 195 },
    text: {
      content: 'Торговое дело\nи логистика',
      isRight: true,
      top: 44,
      width: 179,
      spacing: 0,
    },
    person: {
      src: trade,
      width: 146,
      height: 185,
      top: 0,
      left: 38,
      isMirror: false,
    },
    mountain: {
      src: tradeMountin,
      width: 229,
      height: 151,
      top: 44,
      left: 0,
    },
    modal: {
      width: 370,
      top: 80,
      right: -123,
      $titleWidth: 180,
      $textWidth: 180,
      isMirror: true,
    },
    hasCircle: false,
  },
  {
    id: 'stroy',
    type: 'absolute',
    position: { top: 765, left: 880, width: 233, height: 199 },
    text: {
      content: 'Техника и технологии\nстроительства',
      top: 20,
      width: 231,
      spacing: 50,
    },
    person: {
      src: stroy,
      width: 77,
      height: 175,
      top: 0,
      left: 140,
      isMirror: true,
    },
    mountain: {
      src: stroyMountin,
      width: 233,
      height: 156,
      top: 43,
      left: 0,
    },
    modal: {
      width: 400,
      top: 51,
      right: -20,
      isMirror: false,
      $textWidth: 270,
    },
    hasCircle: false,
  },
  {
    id: 'economy',
    type: 'absolute',
    position: { top: 1007, left: 544, width: 202, height: 184 },
    text: {
      content: 'Экономика\nи финансы',
      isRight: false,
      top: 48,
      width: 182,
      spacing: 35,
    },
    person: {
      src: economy,
      width: 95,
      height: 168,
      top: 0,
      left: 68,
      isMirror: true,
    },
    mountain: {
      src: economyMountin,
      width: 202,
      height: 149,
      top: 35,
      left: 0,
    },
    modal: {
      width: 360,
      top: 80,
      right: -20,
    },
    hasCircle: false,
  },
  {
    id: 'service',
    type: 'absolute',
    position: { top: 1462, left: 655, width: 251, height: 202 },
    text: {
      content: 'Сервис\nи туризм',
      isRight: true,
      top: 62,
      width: 127,
      spacing: 10,
    },
    person: {
      src: service,
      width: 98,
      height: 185,
      top: 43,
      left: 103,
      isMirror: true,
    },
    mountain: {
      src: serviceMountin,
      width: 251,
      height: 163,
      top: 83,
      left: 0,
    },
    modal: {
      width: 390,
      top: 95,
      right: -225,
      isMirror: true,
    },
    hasCircle: false,
  },
  {
    id: 'infosec',
    type: 'absolute',
    position: { top: 553, left: 625, width: 218, height: 192 },
    text: {
      content: 'Информационная\nбезопасность',
      isRight: false,
      top: 20,
      width: 225,
      spacing: 80,
    },
    person: {
      src: infosec,
      width: 175,
      height: 230,
      top: -35,
      left: 46,
      isMirror: true,
    },
    mountain: {
      src: infosecMountin,
      width: 218,
      height: 103,
      top: 89,
      left: 0,
    },
    modal: {
      width: 380,
      top: 50,
      right: -10,
      isMirror: false,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
  {
    id: 'machine',
    type: 'absolute',
    position: { top: 1044, left: 24, width: 306, height: 201 },
    text: {
      content: 'машиностроение',
      isRight: true,
      top: 100,
      width: 167,
      height: 30,
      spacing: 79,
    },
    person: {
      src: machine,
      width: 117,
      height: 181,
      top: 0,
      left: 163,
      isMirror: false,
    },
    mountain: {
      src: machineMountin,
      width: 306,
      height: 175,
      top: 26,
      left: 0,
    },
    modal: {
      width: 400,
      top: 115,
      right: -225,
      isMirror: true,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
  {
    id: 'safetech',
    type: 'absolute',
    position: { top: 1775, left: 1061, width: 283, height: 194 },
    text: {
      content: 'Техносферная безопасность\nи природообустройство',
      isRight: false,
      top: 43,
      width: 288,
      spacing: 175,
    },
    person: {
      src: safetech,
      width: 96 * 1.45,
      height: 180 * 1.45,
      top: -42,
      left: 31,
      isMirror: false,
    },
    mountain: {
      src: safetechMountin,
      width: 283,
      height: 141,
      top: 53,
      left: 0,
    },
    modal: {
      width: 375,
      top: 80,
      right: 120,
      isMirror: false,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
  {
    id: 'energetics',
    type: 'absolute',
    position: { top: 2001, left: 960, width: 320, height: 218 },
    text: {
      content: 'Электро-\nи теплоэнергетика',
      isRight: true,
      top: 40,
      width: 222,
      spacing: 102,
    },
    person: {
      src: energetics,
      width: 120 * 1.35,
      height: 200 * 1.35,
      top: -42,
      left: 121,
      isMirror: false,
    },
    mountain: {
      src: electricsMountin,
      width: 320,
      height: 192,
      top: 26,
      left: 0,
    },
    modal: {
      width: 395,
      top: 65,
      right: 40,
      isMirror: false,
    },
    hasCircle: false,
  },
  {
    id: 'it',
    type: 'absolute',
    position: { top: 563, left: 70, width: 233, height: 235 },
    text: {
      content: 'Информатика\nи вычислительная\nтехника',
      isRight: true,
      top: 18,
      width: 204,
      height: 56,
      spacing: 10,
    },
    person: {
      src: it,
      width: 104 * 1.35,
      height: 189 * 1.35,
      top: -38,
      left: -15,
      isMirror: true,
    },
    mountain: {
      src: itMountin,
      width: 228,
      height: 196,
      top: 39,
      left: 0,
    },
    modal: {
      width: 395,
      top: 60,
      right: -145,
      isMirror: true,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
  {
    id: 'biotech',
    type: 'absolute',
    position: { top: 1292, left: 1022, width: 270, height: 202 },
    text: {
      content: 'Промышленная экология\nи биотехнологии',
      isRight: true,
      top: 23,
      width: 233,
      spacing: 45,
    },
    person: {
      src: biotech,
      width: 92 * 1.45,
      height: 188 * 1.45,
      top: -42,
      left: 10,
      isMirror: false,
    },
    mountain: {
      src: biotechMountin,
      width: 270,
      height: 141,
      top: 61,
      left: 0,
    },
    modal: {
      width: 400,
      top: 43,
      height: 190,
      right: 80,
      $titleWidth: 260,
      isMirror: false,
    },
    hasCircle: false,
  },
  {
    id: 'materials',
    type: 'absolute',
    position: { top: 1691, left: 450, width: 251, height: 206 },
    text: {
      content: 'Технологии\nматериалов',
      isRight: true,
      top: 59,
      width: 160,
      spacing: 91,
    },
    person: {
      src: materials,
      width: 83*1.08,
      height: 189*1.08,
      top: 0,
      left: 134,
      isMirror: true,
    },
    mountain: {
      src: materialsMountin,
      width: 251,
      height: 192,
      top: 14,
      left: 0,
    },
    modal: {
      width: 390,
      top: 90,
      right: -258,
      isMirror: true,
    },
    hasCircle: false,
  },
  {
    id: 'agro',
    type: 'absolute',
    position: { top: 1494, left: 170, width: 223, height: 221 },
    text: {
      content: 'Сельское, лесное\nи рыбное хозяйство',
      isRight: true,
      top: 68,
      width: 239,
      spacing: 160,
    },
    person: {
      src: agro,
      width: 109 * 1.4,
      height: 182 * 1.4,
      top: -35,
      left: 90,
      isMirror: true,
    },
    mountain: {
      src: agroMountin,
      width: 221,
      height: 221,
      top: 0,
      left: 0,
    },
    modal: {
      width: 390,
      top: 100,
      right: -250,
      isMirror: true,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
  {
    id: 'himtech',
    type: 'absolute',
    position: { top: 1965, left: 599, width: 231, height: 231 },
    text: {
      content: 'химические\nтехнологии',
      isRight: true,
      top: 55,
      width: 151,
      spacing: 101,
    },
    person: {
      src: himtech,
      width: 84 * 1.2,
      height: 183 * 1.2,
      top: -25,
      left: 110,
      isMirror: true,
    },
    mountain: {
      src: himtechMountin,
      width: 231,
      height: 231,
      top: 0,
      left: 0,
    },
    modal: {
      width: 410,
      top: 85,
      right: -42,
      isMirror: false,
    },
    hasCircle: true,
  },
  {
    id: 'transport',
    type: 'absolute',
    position: { top: 1548, left: 941, width: 243, height: 222 },
    text: {
      content: 'Техника и технологии\nназемного транспорта',
      isRight: true,
      top: 45,
      width: 228,
      spacing: 166,
    },
    person: {
      src: transportMain,
      width: 112,
      height: 180,
      top: 0,
      left: 131,
      isMirror: true,
    },
    mountain: {
      src: transportMountin,
      width: 235,
      height: 196,
      top: 26,
      left: 0,
    },
    modal: {
      width: 410,
      top: 45,
      height: 210,
      right: -50,
      isMirror: false,
    },
    hasCircle: false,
  },
  {
    id: 'techprom',
    type: 'absolute',
    position: { top: 1725, left: 46, width: 207, height: 236 },
    text: {
      content: 'Технологии легкой\nпромышленности',
      isRight: true,
      top: 64,
      width: 224,
      spacing: 89,
    },
    person: {
      src: techprom,
      width: 128,
      height: 200,
      top: 0,
      left: 10,
      isMirror: true,
    },
    mountain: {
      src: techpromMountin,
      width: 207,
      height: 207,
      top: 29,
      left: 0,
    },
    modal: {
      width: 430,
      top: 100,
      right: -220,
      isMirror: true,
      $paddingTop: 25,
    },
    hasCircle: false,
  },
];